"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRoutes = void 0;
exports.userRoutes = [
    {
        name: 'user.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'user.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'user.logged',
        path: '/logged-user',
        method: 'GET'
    },
    {
        name: 'user.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'user.children',
        path: '/children/:id',
        method: 'GET'
    },
    {
        name: 'user.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'user.delete',
        path: '/:id',
        method: 'DELETE'
    },
    {
        name: 'user.profile.update',
        path: '/edit/profile',
        method: 'PUT'
    },
    {
        name: 'user.account.balance',
        path: '/account/balance',
        method: 'GET'
    },
    {
        name: 'user.password.reset',
        path: '/password/reset',
        method: 'POST'
    },
    {
        name: 'user.password.reset.confirm',
        path: '/password/reset/confirm',
        method: 'POST'
    },
    {
        name: 'user.get-apiKey',
        path: '/:id/api-key',
        method: 'GET'
    }
];
